import ReactPaginate from "react-paginate";
import Chevron from "../../assets/icons/Chevron";

const PageSelector = ({
  page,
  count,
  totalItems,
  className,
  setPage
}: {
  page: number;
  count: number;
  totalItems: number;
  className?: string;
  setPage: (page: number) => void;
}) => (
  <>
    <ReactPaginate
      forcePage={page}
      onPageChange={e => setPage(e.selected)}
      pageCount={Math.ceil(totalItems / count)}
      breakLabel="..."
      className={
        "flex w-fit select-none justify-evenly gap-2 rounded bg-white p-[10px] text-slate-500 shadow-pagination " +
        className
      }
      pageClassName="w-6 h-6 flex items-center justify-center rounded hover:bg-ctb-grey-100 hover:cursor-pointer text-base transition"
      previousClassName="flex items-center justify-center w-6 h-6 transition hover:bg-ctb-grey-100 hover:cursor-pointer rounded"
      nextClassName="flex items-center justify-center w-6 h-6 transition hover:bg-ctb-grey-100 hover:cursor-pointer rounded"
      nextLabel={<Chevron className="h-4 -rotate-90 stroke-[#010D2C]" />}
      previousLabel={<Chevron className="h-4 rotate-90 stroke-[#010D2C]" />}
      activeClassName="text-white hover:!cursor-default"
      activeLinkClassName="!bg-[#010D2C] !text-white rounded"
      pageLinkClassName="w-full text-center"
    />
  </>
);

export default PageSelector;
